import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../../../stores/useAppStore';
import './styles.scss';

export default function SidebarFooter({ type }) {
const navigate = useNavigate();
const currentUser = useAppStore((s) => s.currentUser);

const handleNavigation = () => {
  if (!currentUser) navigate('');
  if (currentUser?.isAdmin) navigate('/app/admin');
  navigate('/app/dashboards');
};

return (
  <div className="sidebar-footer">
    {type !== 'support' ? <div className="footer-content">
      <span onClick={() => navigate('/privacy')} className="footer-link">Privacy</span>
      <span onClick={() => navigate('/terms')} className="footer-link">Terms</span>
      <span onClick={() => navigate('/support')} className="footer-link">Support</span>
    </div> : <div className="footer-content">
      <span onClick={handleNavigation} className="footer-link">Dashboard</span>
    </div>}
    <div className="footer-app-name">© {new Date().getFullYear()} <strong>ZIN</strong>BOARD</div>
  </div>
)};